import React from "react";
import { Link } from "react-router-dom";
import "../../../style/scss/main.scss";

const Esepration: React.FC = () => {
  return (
    <div className="container-fluid mt-4 e-separation-page px-4">
      <div className="card p-5 mx-auto" style={{maxWidth:1100}}>
        <div className="text-center mb-4">
          <div className="logo mb-3">
            <div style={{width:80,height:80,borderRadius:40,background:'#e53935',display:'inline-block'}}></div>
          </div>
          <h1 className="h3">DMRC E-Separation Portal</h1>
          <p className="text-muted">Human Resource Management System - Delhi Metro Rail Corporation</p>
        </div>

        <div className="mb-4">
          <label className="form-label">Select Your Role</label>
          <select className="form-control">
            <option>Choose your role to continue...</option>
            <option>Employee - Submit resignation and track status</option>
            <option>Approver (HOD/GM/CA) - Review and approve requests</option>
            <option>HR - Manage no-dues and final settlements</option>
            <option>Nodal Officer - Process departmental clearances</option>
          </select>
        </div>

        <div className="bg-light p-3 rounded">
          <h4>Complete E-Separation Workflow</h4>
          <ul>
            <li>Intimation & Resignation submission</li>
            <li>Short Notice requests</li>
            <li>Withdrawal & Bond Waiver</li>
            <li>Multi-level approval workflow</li>
            <li>Parallel No-Dues clearance</li>
            <li>Final settlement & documents</li>
          </ul>
        </div>

        <div className="mt-4 d-flex justify-content-end">
          <Link to="/" className="btn btn-secondary me-2">Back</Link>
          <button className="btn btn-primary">Proceed</button>
        </div>
      </div>
    </div>
  );
};

export default Esepration;
